import { Typography } from "@mui/material";
import { RuleSuggestionSource } from "generated-graphql/graphql";
import { ComponentType } from "react";

import { CersCupaPreferenceProvenance } from "./CersCupaPreferenceProvenance";

function GenericProvenance({ provenance }: { provenance: unknown }) {
  return (
    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}>
      {JSON.stringify(provenance, null, 2)}
    </Typography>
  );
}

const RENDERERS: Partial<Record<RuleSuggestionSource, ComponentType<{ provenance: unknown }>>> = {
  [RuleSuggestionSource.CersCupaPreference]: CersCupaPreferenceProvenance,
};

export function provenanceRendererFor(
  source: RuleSuggestionSource
): ComponentType<{ provenance: unknown }> {
  return RENDERERS[source] ?? GenericProvenance;
}
